export const services = [
  {
    title: 'Consultoria Estratégica',
    description:
      'Desenvolvemos diagnósticos, orientações e planos de ação para a formulação, implementação e qualificação de políticas de inclusão, acessibilidade e diversidade. Cada projeto é estruturado a partir da realidade, da maturidade institucional e dos objetivos de cada organização, com precisão metodológica e olhar personalizado.',
    icon: '/assets/icons/search.svg',
    cardClassName: 'bg-white-950 text-white-50',
    iconClassName: 'bg-lightning-yellow-500',
  },
  {
    title: 'Formação e Capacitação',
    description:
      'Oferecemos cursos, oficinas, palestras, treinamentos e programas formativos para lideranças, equipes técnicas, gestores públicos, profissionais de empresas e organizações sociais. Os conteúdos são desenhados para unir profundidade conceitual, aplicabilidade prática e repertório institucional.',
    icon: '/assets/icons/student.svg',
    cardClassName: 'bg-white-50 text-black-950',
    iconClassName: 'bg-lightning-yellow-500',
  },
  {
    title: 'Assessoria em Projetos e Eventos',
    description:
      'Apoiamos o planejamento e a execução de projetos sociais, culturais e educacionais, bem como eventos institucionais e corporativos, com atenção especial à acessibilidade, à comunicação inclusiva e à experiência do público.',
    icon: '/assets/icons/buildings.svg',
    cardClassName: 'bg-[#F1BD03] text-black-950',
    iconClassName: 'bg-lightning-yellow-50',
  },
  {
    title: 'Advocacy e Pesquisa Aplicada',
    description:
      'Produzimos estudos, relatórios, pareceres técnicos e estratégias de incidência voltados à promoção dos direitos humanos, da inclusão e da acessibilidade, inclusive em interlocução com redes nacionais e organismos internacionais.',
    icon: '/assets/icons/lightbulb.svg',
    cardClassName: 'bg-[#202020] text-white-50',
    iconClassName: 'bg-lightning-yellow-500',
  },
]
